import React from 'react';

function Footer() {
  return (
    <footer>
      <span>&copy; Kibrewossen</span>
      {' '}
      All right reserved. 2023
    </footer>
  );
}

export default Footer;
